import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useNavigate } from "react-router-dom";

/* IMPORT IMAGE */
import about1 from "../assets/HomePage/about.jpg";

export default function AboutUs() {
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.3, once: false });
  const navigate = useNavigate();

  return (
    <section id="about-section" className="w-full py-20 bg-white">
      <div
        ref={ref}
        className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-16 items-center"
      >
        {/* LEFT IMAGE */}
        <motion.div
          initial={{ opacity: 0, x: -80 }}
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -80 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={about1}
            alt="About Ceymos Lanka"
            className="w-full h-auto object-contain rounded-xl shadow-md"
          />
        </motion.div>

        {/* RIGHT CONTENT */}
        <motion.div
          initial={{ opacity: 0, x: 80 }}
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: 80 }}
          transition={{ duration: 0.8, delay: 0.15 }}
        >
          <h2 className="text-4xl md:text-5xl font-serif text-[#3A2F2A] mb-8">
            About Our Company
          </h2>

          <h3 className="text-lg font-semibold text-[#3A2F2A] mb-4">
            Ceylon Tea Workers
          </h3>

          <p className="text-gray-700 leading-relaxed mb-6">
            Welcome to <span className="font-semibold">Ceymos Lanka</span> —
            your gateway to the finest Ceylon tea, spices, and coconut products.
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            Rooted in over 30 years of family tradition, we bring heritage,
            craftsmanship, and global expertise together.
          </p>

          <p className="text-gray-700 leading-relaxed mb-8">
            Our tea is grown in lush Sri Lankan highlands, processed with care
            to preserve richness and authentic flavour.
          </p>

          {/* GALLERY BUTTON */}
          <button
            type="button"
            onClick={() => navigate("/gallery")}
            className="inline-flex items-center px-6 py-3 rounded-lg
                       bg-[#3A2F2A] text-white font-medium
                       hover:bg-[#2c2420] transition-colors duration-300"
          >
            Gallery
          </button>
        </motion.div>
      </div>
    </section>
  );
}
